import React from 'react';
import {
  getHeroContent, TopControls, TabContent, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';

export default function CraftLayout({ p }) {
  // const theme = p.storeTheme || {};
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Crafted for everyday joy",
    title: "Thoughtful goods with a handmade soul",
    subtitle: "Discover pieces made in small runs by trusted creators. From home accents to practical essentials, every product is selected for quality and character.",
    primaryCta: "Browse Collection",
  });
  const pages = ["products", "services", "details"];
  const activeProduct = p.activeTab || "products";
  const setActiveProduct = p.setActiveTab;
  const search = p.searchQuery || "";
  const setSearch = p.setSearchQuery;
  const selectedCategory = p.activeTab || "products";
  const setSelectedCategory = p.setActiveTab;
  const cartCount = p.cart?.reduce((sum, item) => sum + (item.cartQuantity || 1), 0) || 0;
  const store = {
    wishlistCount: p.wishlistCount || 0,
    handleWishlist: p.handleGoToWishlist,
    cartCount,
    handleCart: p.handleOpenCart,
  };
  const ProductGrid = () => <TabContent p={p} />;

  return (
    <div className="min-h-screen bg-[#f7f2ea] text-[#3b2b21]">
      <div className="mx-auto w-full max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-[#d9c7b1] bg-[#efe3d2] px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-[#7a5a42]">
          Handmade picks • Local craft • Limited batches
        </div>

        <div className="mt-4 grid gap-5 lg:grid-cols-[1.35fr_0.65fr]">
          <div className="rounded-3xl border border-[#ddc8b0] bg-[#fbf7f1] p-6 shadow-[0_18px_45px_rgba(90,60,30,0.12)] sm:p-8">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#e7d2bb] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#7a5337]"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></div>
            <h1 className="mt-4 text-3xl font-semibold tracking-tight text-[#2f2018] sm:text-4xl"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
            <p className="mt-3 max-w-2xl text-sm text-[#6b4d3a] sm:text-base"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={p.handleBackToLanding}
                className="rounded-full bg-[#6f4227] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#5e3821]"
              >
                {text.back || "Back"}
              </button>
              <button
                type="button"
                onClick={() => {
                  if (typeof window !== "undefined") {
                    window.scrollTo({ top: 620, behavior: "smooth" });
                  }
                }}
                className="rounded-full border border-[#be9b7f] bg-[#fff7ef] px-5 py-2 text-sm font-semibold text-[#6a452f] transition hover:bg-[#f7ecdf]"
              ><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
            </div>
          </div>

          <div className="grid gap-4 rounded-3xl border border-[#ddc8b0] bg-[#f4e6d5] p-5">
            {[
              { label: "Artisan Partners", value: "180+" },
              { label: "Avg. Dispatch", value: "24h" },
              { label: "Happy Buyers", value: "12k" },
            ].map((item) => (
              <div
                key={item.label}
                className="rounded-2xl border border-[#d4b89b] bg-[#fff7ed] px-4 py-4"
              >
                <p className="text-[11px] font-semibold uppercase tracking-[0.13em] text-[#8a684f]">
                  {item.label}
                </p>
                <p className="mt-1 text-2xl font-semibold text-[#4f321f]">{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        {/* TopControls + Profile section side by side */}
        <div className="mt-6 rounded-2xl border border-[#dcc5ad] bg-[#fff9f2] p-3 shadow-sm">
          <div className="flex items-center gap-2">
            <div className="flex-1 min-w-0">
              <TopControls
                search={search}
                setSearch={setSearch}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                categories={pages}
                store={store}
                showCategoryInSearch={false}
                shellClassName="border-[#e3cfba] bg-[#fffdf9]"
                searchClassName="h-11 border-[#d5b99d] bg-[#fff6ea] text-[#4a311f] placeholder:text-[#9d7b61] focus:ring-[#7c4b2c]/35"
                selectClassName="h-11 border-[#d5b99d] bg-[#fff6ea] text-[#5d3d2a] focus:ring-[#7c4b2c]/35"
                rightActionsClassName="gap-2"
                iconButtonClassName="border-[#d4b499] bg-[#fff6ec] text-[#6e442a] hover:bg-[#f4e6d6]"
              />
            </div>
            {p.userMenuElement && (
              <div className="shrink-0 border-l border-[#e3cfba] pl-2">
                {p.userMenuElement}
              </div>
            )}
          </div>
        </div>

        <div className="mt-5 overflow-x-auto pb-1">
          <div className="flex min-w-max items-center gap-2">
            {pages.map((page) => {
              const active = activeProduct === page;
              return (
                <button
                  key={page}
                  type="button"
                  onClick={() => setActiveProduct(page)}
                  className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
                    active
                      ? "bg-[#6f4227] text-white shadow-[0_8px_24px_rgba(95,56,31,0.32)]"
                      : "border border-[#d0b396] bg-[#fff7eb] text-[#704933] hover:bg-[#f8eadb]"
                  }`}
                >
                  {getTabLabel(p, page)}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-[1fr_280px]">
          <div className="rounded-3xl border border-[#dec7ae] bg-[#fffdf9] p-4 sm:p-5">
            <ProductGrid />
          </div>

          <aside className="space-y-4">
            <div className="rounded-3xl border border-[#dcc4a9] bg-[#f8ecde] p-5">
              <h3 className="text-base font-semibold text-[#513321]">{text.storeInfo || "Store Info"}</h3>
              <div className="mt-3 space-y-2 text-sm text-[#694a36]">
                <p>Curated assortments updated every week.</p>
                <p>Safe checkout and quick support responses.</p>
                <p>Transparent pricing with no hidden costs.</p>
              </div>
            </div>
            <div className="rounded-3xl border border-[#dcc4a9] bg-[#fff5e8] p-5">
              <h3 className="text-base font-semibold text-[#513321]">{text.contact || "Contact"}</h3>
              <p className="mt-2 text-sm text-[#6f503b]">
                Contact our team for custom quotes and shipping plans for business purchases.
              </p>
              <button
                type="button"
                className="mt-4 w-full rounded-xl border border-[#b88f70] bg-[#fff9f3] px-4 py-2.5 text-sm font-semibold text-[#6d452b] transition hover:bg-[#f8ebdb]"
              >
                {text.callNow || "Call Now"}
              </button>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}